<template>
  <div class="login-auth-container auth-container">
    <back-btn
      dark
      v-if="0"
      :class="{ 'hidden': !authType || authType === 'playphone-last-step' }"
      :should-pop="$route.params.type !== 'reset'"
      :back-route="{ name: 'login' }"
      :text="$t('auth.back')"
    />
    <auth-methods :params="params" :authType="authType" @changeAuthType="changeAuthType" @authenticated="goToBrowse" />
  </div>
</template>

<script>
export default {
  name: 'login-auth-container',
  props: {
    authType: String
  },
  data: () => ({
    params: {}
  }),
  methods: {
    changeAuthType(type, params, replace) {
      this.params = params
      const route = { name: 'login', params: { type, ...params }, query: { ...this.$route.query } }

      if (replace) {
        this.$router.replace(route)
      } else {
        this.$router.push(route)
      }
    },
    goToBrowse() {
      this.$router.push({ name: 'browse', params: { ...this.$route.params }, query: { ...this.$route.query } })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-auth-container {
  display: flex;
  flex-direction: column;
}
</style>
